export * from './link-records-demo.component';
